export default "__VITE_ASSET__DZJMRg3o__"